import type { MappingSource } from '../../constants'
import { MAPPING_SOURCES } from '../../constants'

export type AccountMappingState = {
  isMapped: boolean
  isSaved: boolean
  remappedByUser: boolean
  proposalSource: MappingSource | undefined
}

/**
 * Can AI override this account's current mapping?
 *
 * Priority order:
 *   External (1) > Account Range / Original Number (2) > AI (3) > Exact Match (4)
 *
 * AI can map an account if:
 * - The account has no mapping at all, OR
 * - The account's only mapping is an exact_match pre-population (coincidental identity:
 *   mapped number == original number) that hasn't been saved or remapped by the user
 *
 * AI is blocked by: external, account_range, original_number (configured remapping where
 * mapped number != original number), saved mappings, user remaps
 */
export function canAIOverride(state: AccountMappingState): boolean {
  if (!state.isMapped) return true

  if (state.isSaved || state.remappedByUser) return false

  return state.proposalSource === MAPPING_SOURCES.EXACT_MATCH
}

/**
 * Does the account need to be removed from its current group
 * before being added to the AI's target group?
 *
 * True when the account is currently in a group (i.e., AI is replacing,
 * not just adding). The caller must look up the current group ID from the store.
 */
export function needsRemovalFromCurrentGroup(
  state: AccountMappingState
): boolean {
  return state.isMapped
}
